const getProductTreatmentDefinition = ({
  treatments,
  productPositionOneBased,
}) =>
  treatments?.configuration[0]?.treatmentDefinitions[0].pinnedProducts
    .filter(({ pinType }) => pinType === "elevated")
    .find(({ position }) => position === productPositionOneBased);

export default getProductTreatmentDefinition;
